import axios from 'axios';
export const VideoProgressApiPath = '/video-progress';
export const trackVideoProgress = async (ilHost, businessUnit, videoId, event) => {
  const requestUrl = `https://${ilHost}/integrationlayer/2.0/${businessUnit}/media/video/${videoId}/playerEvent`;
  await axios.post(requestUrl, event);
};